// extracted by mini-css-extract-plugin
export default {"root":"_2kAK4","content":"-OyqQ","head":"_3yAeP"};